import { init } from '@sentry/browser'

if (process.env.NODE_ENV === 'production') {
  init({ dsn: process.env.VUE_APP_DSN })
}
